import { observer } from 'mobx-react'
import React, { useEffect } from 'react'
import { MapStore } from 'store/map'
import { CURRENT_OS, KOREA_CENTER, OS } from 'infra/constant'
import { ColumnLayout } from 'ui/common/layout'
import { colors } from 'infra/color'
import NaverMapView from 'react-native-nmap'
import { View } from 'react-native'
import styled from 'styled-components'
import { UserLocationMarker } from 'ui/common/user-location-marker'
import { CurrentLocationButton } from 'ui/common/current-location-button'

export const DefaultMapView: React.FC<{
  mapStore: MapStore
  MapViewChildren: React.FC
  MapOverlayChildren: React.FC
}> = observer(({ mapStore, MapViewChildren, MapOverlayChildren }) => {
  useEffect(() => {
    // ios map init flow
    if (CURRENT_OS === OS.IOS) {
      setTimeout(() => mapStore.setIsReady(true))
    }
    return () => {
      mapStore.setIsReady(false)
    }
  }, [mapStore])
  return (
    <ColumnLayout style={{ flex: 1, backgroundColor: colors.white }}>
      {/* @ts-ignore */}
      <NaverMapView
        ref={mapStore.mapRef}
        center={KOREA_CENTER}
        compass={false}
        scaleBar={false}
        zoomControl={false}
        tiltGesturesEnabled={false}
        rotateGesturesEnabled={false}
        style={{ flex: 1 }}
        // https://github.com/QuadFlask/react-native-naver-map/issues/117
        useTextureView={true}
        onCameraChange={(c) => {
          // @ts-ignore
          // 라이브러리에서 내려주는 타입이 잘못됨
          mapStore.setCamera(c)
        }}
        onMapClick={() => {
          mapStore.onNonMarkerTouch()
        }}
        onInitialized={() => {
          // android + web map init flow
          if (CURRENT_OS === OS.ANDROID || CURRENT_OS === OS.WEB) {
            mapStore.setIsReady(true)
          }
        }}
      >
        <UserLocationMarker />
        <MapViewChildren />
      </NaverMapView>
      <MapOverlay pointerEvents='box-none'>
        <MapOverlayChildren />
        <CurrentLocationButton mapStore={mapStore} />
      </MapOverlay>
    </ColumnLayout>
  )
})

const MapOverlay = styled(View)`
  position: absolute;
  width: 100%;
  height: 100%;
`
